import React, { memo } from 'react'
import { colors } from 'src/theme/colors'
import Link from 'next/link'
import { ModuleExtendedApi } from 'src/service/api/api.types'
import { CardPropsStyles, ImageContainer, ItemTitle, TitleContent, Wrapper } from './styles'

export type CardPresets = keyof typeof presets

interface CardProps {
  data: ModuleExtendedApi
  imageUrl: string
  link: string
  className: string
  isIcon: boolean
}

function CardComponent(props: CardProps) {
  const presetStyles = presets.secondary

  const totalOfVideos = total => {
    const map = {
      0: '',
      1: ' - (1 vídeo)',
    }

    return Object.prototype.hasOwnProperty.call(map, total) ? map[total] : ` - (${total} vídeos)`
  }

  return (
    <Link legacyBehavior passHref href={props.link}>
      <Wrapper className={props.className} title={props.data?.title} {...presetStyles}>
        <ImageContainer>
          <img
            className={props.isIcon ? 'icon' : 'image'}
            src={props.imageUrl}
            alt={props.data?.title}
          />
        </ImageContainer>
        <TitleContent>
          <ItemTitle>{`${props.data?.title} ${totalOfVideos(
            props.data.lessons.length,
          )}`}</ItemTitle>
        </TitleContent>
      </Wrapper>
    </Link>
  )
}

interface Presets {
  [key: string]: CardPropsStyles
}

const presets: Presets = {
  secondary: {
    color: colors.primaryTextColor,
    backgroundColor: colors.palette.neutral300,
  },
}

export const ModuleCard = memo(CardComponent)
